import { useSyncExternalStore } from 'react';
import { Icon } from './icon';

/** Toasts with the mockup look (.toast-wrap/.toast). `toast('נשמר')` from anywhere. */
type T = { id: number; msg: string; tone: 'ok' | 'error' };
let items: T[] = [];
let seq = 0;
const subs = new Set<() => void>();
const notify = () => subs.forEach((f) => f());

export function toast(msg: string, tone: 'ok' | 'error' = 'ok'): void {
  const id = ++seq;
  items = [...items, { id, msg, tone }];
  notify();
  setTimeout(() => {
    items = items.filter((t) => t.id !== id);
    notify();
  }, 3200);
}

export function Toaster() {
  const list = useSyncExternalStore(
    (cb) => (subs.add(cb), () => subs.delete(cb)),
    () => items,
  );
  return (
    <div className="toast-wrap" role="status">
      {list.map((t) => (
        <div key={t.id} className={`toast${t.tone === 'error' ? ' error' : ''}`}>
          <Icon name={t.tone === 'error' ? 'alert' : 'check'} />
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}
